import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const rejectReturn = createAsyncThunk("rejectReturn", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.put(`returns/reject/${id}`, data);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while rejecting return");
	}
});

const ReturnRejectSlice = createSlice({
	name: "ReturnRejectSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(rejectReturn.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(rejectReturn.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(rejectReturn.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default ReturnRejectSlice.reducer;
